// src/components/Mentors.js
import React from 'react';
import '../css/Mentors.css';
import Name1 from '../image/np1747056673_04050f3f1d4d6d378a6c.jpg';
import Name2 from '../image/np1747056624_95efce0c2f76272141ab.jpg';
import Name3 from '../image/np1747056475_42d0c80408f9410642ea.png';
import Name4 from '../image/np1747046605_1a18289d9103d999e855.png';

const Mentors = () => {
  const mentors = [
    {
      name: "Shri Arif Mohammad Khan",
      position: "Hon’ble Chancellor-cum-Governor of Bihar",
      image: Name1
    },
    {
      name: "Shri. Nitish Kumar",
      position: "Hon’ble Chief Minister, Bihar",
      image: Name2
    },
    {
      name: "Prof. S.P Shahi",
      position: "Hon’ble Vice Chancellor",
      image: Name3
    },
    {
      name: "Prof. (Dr.) Deepak Kumar",
      position: "Principal",
      image: Name4
    }
  ];

  return (
    <section className="mentors">
      <div className="mentors-container h2">
        <h2>Our Mentors</h2>
        <div className="mentors-grid">
          {mentors.map((mentor, index) => (
            <div className="mentor-card" key={index}>
              <img src={mentor.image} alt={mentor.name} />
              <h3>{mentor.name}</h3>
              <p>{mentor.position}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mentors;
